import Viewport from '../core/Viewport';

export const getMaxScroll = () => (Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - Viewport.height);

/**
 * @returns {boolean}
 */
export const isTouch = () => !document.documentElement.classList.contains('using-mouse');

/**
 * @returns {boolean}
 */
export const isLivePreview = () => document.documentElement.classList.contains('is-preview') && document.documentElement.classList.contains('is-iframe');

/**
 * @param value
 * @param props
 * @returns {any}
 */
export const t = (value, props = {}) => {
    const i18n = Config.get('i18n', {});
    let text = i18n[value] || value;
    Object.keys(props).forEach(key => {
        text = text.replaceAll(`{${key}}`, props[key]);
    });
    return text;
};
